import worldChampion from "../../assets/img/roster/champions/WorldChampion.png";
import wweChampion from "../../assets/img/roster/champions/WWEChampion.png";
import usChampion from "../../assets/img/roster/champions/USChampion.png";
import icChampion from "../../assets/img/roster/champions/ICChampion.png";
import wweTagChampions from "../../assets/img/roster/champions/WWETagChampions.png";
import worldTagChampions from "../../assets/img/roster/champions/WorldTagChampions.png";
import worldWomenChampion from "../../assets/img/roster/champions/WorldWomenChampion.png";
import wweWomenChampion from "../../assets/img/roster/champions/WWEWomenChampion.png";
import usWomenChampion from "../../assets/img/roster/champions/USWomenChampion.png";
import icWomenChampion from "../../assets/img/roster/champions/ICWomenChampion.png";
import womenTagChampions from "../../assets/img/roster/champions/TagWomensChampions.png";
import nxtChampion from "../../assets/img/roster/champions/NXTChampion.png";
import northAmericanChampion from "../../assets/img/roster/champions/NAChampion.png";
import nxtTagChampions from "../../assets/img/roster/champions/NXTTagChampions.png";
import nxtWomenChampion from "../../assets/img/roster/champions/NXTWomenChampion.png";
import nxtWomenNaChampion from "../../assets/img/roster/champions/NAWomenChampion.png";

import brayWyatt from "../../assets/img/roster/wyatt/BrayWyatt.png";
import uncleHowdy from "../../assets/img/roster/wyatt/UncleHowdy.png";
import lukeHarper from "../../assets/img/roster/wyatt/LukeHarper.png";
import erickRowan from "../../assets/img/roster/wyatt/Rowan.png";
import Rowan from "../../assets/img/roster/wyatt/RowanSheep1.png";
import braunStrowman from "../../assets/img/roster/wyatt/Strowman.png";
import dexterLumis from "../../assets/img/roster/wyatt/DexterLumis.png";
import joeGacy from "../../assets/img/roster/wyatt/JoeGacy.png";
import nikkiCross from "../../assets/img/roster/wyatt/Nikki.png";
import fiend from "../../assets/img/roster/wyatt/TheFiend.png";
import wyattfamily from "../../assets/img/roster/wyatt/WyattFamily.png";
import wyattSicks from "../../assets/img/roster/wyatt/WyattSicks.png";

import soloSikoa from "../../assets/img/roster/mft/SoloSikoa.png";
import tamaTonga from "../../assets/img/roster/mft/TamaTonga1.png";
import tongaLoa from "../../assets/img/roster/mft/TangaLoa.png";
import jcMateo from "../../assets/img/roster/mft/JCMateo.png";
import tallaTonga from "../../assets/img/roster/mft/TallaTonga.png";
import mft from "../../assets/img/roster/mft/MFT.png";

export const rosterTabs = [
  {
    id: "first",
    label: "Champions",
    variant: "champions",
    items: [
      {
        id: "roman-reigns",
        title: "Roman Reigns",
        description: "World Champion",
        imgUrl: worldChampion,
      },
      {
        id: "cm-punk",
        title: "CM Punk",
        description: "WWE Champion",
        imgUrl: wweChampion,
      },
      {
        id: "baron-corbin",
        title: "Baron Corbin",
        description: "United States Champion",
        imgUrl: usChampion,
      },
      {
        id: "chad-gable",
        title: "Chad Gable",
        description: "Intercontinental Champion",
        imgUrl: icChampion,
      },
      {
        id: "mft-tag",
        title: "MFT",
        description: "WWE Tag Team Champions",
        imgUrl: wweTagChampions,
      },
      {
        id: "vision",
        title: "The Vision",
        description: "World Tag Team Champions",
        imgUrl: worldTagChampions,
      },
      {
        id: "liv-morgan",
        title: "Liv Morgan",
        description: "World Women´s Champion",
        imgUrl: worldWomenChampion,
      },
      {
        id: "chelsea-green",
        title: "Chelsea Green",
        description: "Interim WWE Women´s Champion",
        imgUrl: wweWomenChampion,
      },
      {
        id: "jacy-jayne",
        title: "Jacy Jayne",
        description: "United States Women´s Champion",
        imgUrl: usWomenChampion,
      },
      {
        id: "raquel-rodriguez",
        title: "Raquel Rodriguez",
        description: "Intercontinental Women´s Champion",
        imgUrl: icWomenChampion,
      },
      {
        id: "fatal-influence",
        title: "Fatal Influence",
        description: "World Tag Team Women´s Champions",
        imgUrl: womenTagChampions,
      },
      {
        id: "tony-d'angelo",
        title: "Tony D'Angelo",
        description: "NXT Champion",
        imgUrl: nxtChampion,
      },
      {
        id: "myles-borne",
        title: "Myles Borne",
        description: "NXT North American Champion",
        imgUrl: northAmericanChampion,
      },
      {
        id: "borne-heights",
        title: "Myles Borne & Tavion Heights",
        description: "NXT Tag Team Champions",
        imgUrl: nxtTagChampions,
      },
      {
        id: "kendal-grey",
        title: "Kendal Grey",
        description: "NXT Women´s Champion",
        imgUrl: nxtWomenChampion,
      },
      {
        id: "Zaria",
        title: "Zaria",
        description: "NXT Women´s North American Champion",
        imgUrl: nxtWomenNaChampion,
      },
    ],
  },
  {
    id: "second",
    label: "Wyatts",
    variant: "wyatts",
    items: [
      {
        id: "bray-wyatt",
        title: "Bray Wyatt",
        description: "Wyatt Patriarch",
        imgUrl: brayWyatt,
      },
      {
        id: "uncle-howdy",
        title: "Uncle Howdy",
        description: "Wyatt Sicks Leader",
        imgUrl: uncleHowdy,
      },
      {
        id: "luke-harper",
        title: "Luke Harper",
        description: "Wyatt Son",
        imgUrl: lukeHarper,
      },
      {
        id: "erick-rowan",
        title: "Erick Rowan",
        description: "Wyatt Son Sheep",
        imgUrl: Rowan,
      },
      {
        id: "braun-strowman",
        title: "Braun Strowman",
        description: "The Black Sheep",
        imgUrl: braunStrowman,
      },
      {
        id: "erick-rowan-2",
        title: "Erick Rowan",
        description: "Ramblin´ Rabbit",
        imgUrl: erickRowan,
      },
      {
        id: "dexter-lumis",
        title: "Dexter Lumis",
        description: "Mercy The Buzzard",
        imgUrl: dexterLumis,
      },
      {
        id: "joe-gacy",
        title: "Joe Gacy",
        description: "Huskus The Pig",
        imgUrl: joeGacy,
      },
      {
        id: "nikki-cross",
        title: "Nikki Cross",
        description: "Abby The Witch",
        imgUrl: nikkiCross,
      },
      {
        id: "fiend",
        title: "'The Fiend'",
        description: "Bray Wyatt",
        imgUrl: fiend,
      },
      {
        id: "wyatt-family",
        title: "Wyatt Family",
        description: "Faction",
        imgUrl: wyattfamily,
      },
      {
        id: "wyatt-sicks",
        title: "Wyatt Sicks",
        description: "Faction",
        imgUrl: wyattSicks,
      },
    ],
  },
  {
    id: "third",
    label: "MFT",
    variant: "mft",
    items: [
      {
        id: "solo-sikoa",
        title: "Solo Sikoa",
        description: "MFT Leader",
        imgUrl: soloSikoa,
      },
      {
        id: "tama-tonga",
        title: "Tama Tonga",
        description: "MFT Right Hand",
        imgUrl: tamaTonga,
      },
      {
        id: "tonga-loa",
        title: "Tonga Loa",
        description: "MFT Member",
        imgUrl: tongaLoa,
      },
      {
        id: "jc-mateo",
        title: "JC Mateo",
        description: "MFT Member",
        imgUrl: jcMateo,
      },
      {
        id: "talla-tonga",
        title: "Talla Tonga",
        description: "MFT Enforcer",
        imgUrl: tallaTonga,
      },
      { id: "mft", title: "MFT", description: "My Family Tree", imgUrl: mft },
    ],
  },
];
